<template>
  <LandingCard v-if="hasItems || hasLoadError" :title="title">
    <p v-if="hasLoadError" class="bg-yellow-50 px-6 py-3 text-sm text-neutral-700">
      Some of your cards and classes could not be loaded. Refresh to try again.
    </p>
    <LandingCardEntityList title="Cards" :items="cards">
      <template #default="{ item }">
        <LandingCardEntityListItem :primary-label="item.primaryLabel" :secondary-label="item.secondaryLabel">
          <template #additionalInfo>
            <div class="mt-1.5 text-sm text-neutral-400 md:mt-0 md:self-center md:pr-4 md:text-right">
              <span class="md:block" :class="{ 'font-semibold text-red-500': item.emphasizeAdditionalInfo }">
                {{ item.additionalInfo }}
              </span>
              <span class="text-neutral-500" :class="{ 'font-semibold': item.emphasizeAdditionalInfo }">
                {{ item.additionalInfoDetail }}
              </span>
            </div>
          </template>
        </LandingCardEntityListItem>
      </template>
    </LandingCardEntityList>
    <LandingCardEntityList title="Scheduled Classes" :items="scheduledClasses">
      <template #default="{ item }">
        <LandingCardEntityListItem :primary-label="item.primaryLabel" :secondary-label="item.secondaryLabel">
          <template #additionalInfo>
            <div
              class="mt-1.5 text-sm text-neutral-400 md:mt-0 md:self-center md:pr-4 md:text-right"
              v-if="item.additionalInfo"
            >
              {{ item.additionalInfo }}
            </div>
          </template>
        </LandingCardEntityListItem>
      </template>
    </LandingCardEntityList>
    <LandingCardEntityList title="Awaiting Scheduling" :items="awaitingScheduling" variant="warn">
      <template #default="{ item }">
        <LandingCardEntityListItem :primary-label="item.primaryLabel" :secondary-label="item.secondaryLabel">
          <template #additionalInfo>
            <div class="mt-1.5 text-sm text-neutral-400 md:mt-0 md:self-center md:pr-4 md:text-right">
              {{ item.additionalInfo }}
            </div>
          </template>
        </LandingCardEntityListItem>
      </template>
    </LandingCardEntityList>
  </LandingCard>
</template>

<script lang="ts">
import type { CardsAndClassesItem } from "@/components/homeExternalCardsAndClasses";
import { hasCardsAndClassesContent } from "@/components/homeExternalCardsAndClasses";
import LandingCard from "@/components/landing/LandingCard.vue";
import LandingCardEntityList from "@/components/landing/LandingCardEntityList.vue";
import LandingCardEntityListItem from "@/components/landing/LandingCardEntityListItem.vue";
import { computed, defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "HomeExternalCardsAndClassesCard",
  components: {
    LandingCard,
    LandingCardEntityList,
    LandingCardEntityListItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    cards: {
      type: Array as PropType<CardsAndClassesItem[]>,
      required: true,
    },
    scheduledClasses: {
      type: Array as PropType<CardsAndClassesItem[]>,
      required: true,
    },
    awaitingScheduling: {
      type: Array as PropType<CardsAndClassesItem[]>,
      required: true,
    },
    hasLoadError: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hasItems = computed(() =>
      hasCardsAndClassesContent({
        cards: props.cards,
        scheduledClasses: props.scheduledClasses,
        awaitingScheduling: props.awaitingScheduling,
      }),
    );

    return { hasItems };
  },
});
</script>
